export default {"src":"/_next/static/media/live-casino.b8ee75b5.svg","height":62,"width":49,"blurWidth":0,"blurHeight":0};